<div class="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 flex">
  <!-- Left Panel - Login Form -->
  <div class="w-full lg:w-1/2 flex items-center justify-center p-8">
    <div class="w-full max-w-md">
      <div class="bg-white rounded-2xl shadow-xl p-8">
        <!-- Logo -->
        <div class="text-center mb-8">
          <div class="w-16 h-16 bg-orange-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <div class="w-8 h-8 bg-white rounded-lg"></div>
          </div>
          <h1 class="text-2xl font-bold text-gray-900">Bem-vindo</h1>
          <p class="text-gray-600 mt-2">Acesse sua conta para continuar</p>
        </div>

        <!-- Login Form -->
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6" novalidate>
          <div>
            <label for="login" class="block text-gray-700">Login</label>
            <input
              id="login"
              formControlName="login"
              class="mt-2 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-orange-400"
            />
            <div *ngIf="form.controls['login'].invalid && form.controls['login'].touched" class="text-red-600 text-sm mt-1">
              Login inválido
            </div>
          </div>

          <div>
            <label for="password" class="block text-gray-700">Senha</label>
            <div class="relative mt-2">
              <input
                id="password"
                [type]="showPassword ? 'text' : 'password'"
                formControlName="password"
                class="p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-orange-400 pr-10"
              />
              <button
                type="button"
                (click)="toggleShowPassword()"
                class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none"
                aria-label="Mostrar/ocultar senha"
              >
                <i *ngIf="showPassword" class="pi pi-eye-slash"></i>
                <i *ngIf="!showPassword" class="pi pi-eye"></i>
              </button>
            </div>
            <div *ngIf="form.controls['password'].invalid && form.controls['password'].touched" class="text-red-600 text-sm mt-1">
              A senha é obrigatória
            </div>
          </div>

          <div *ngIf="error" class="text-red-600 text-sm text-center">{{ error }}</div>

          <button
            type="submit"
            class="w-full cursor-pointer bg-orange-500 hover:bg-orange-600 text-white py-2 rounded"
            [disabled]="isLoading"
          >
            {{ isLoading ? 'Entrando...' : 'Entrar' }}
          </button>
        </form>
      </div>
    </div>
  </div>

  <!-- Right Panel - Background with floating icons -->
  <div class="hidden lg:block lg:w-1/2 relative bg-orange-500 overflow-hidden">
    <div class="absolute inset-0 bg-opacity-10"></div>

    <!-- Floating Icons -->
    <div class="absolute top-20 left-20 text-white opacity-80">
      <i class="pi pi-lightbulb" style="font-size: 40px;"></i>
    </div>
    <div class="absolute top-40 right-32 text-white opacity-60">
      <i class="pi pi-globe" style="font-size: 32px;"></i>
    </div>
    <div class="absolute bottom-40 left-32 text-white opacity-70">
      <i class="pi pi-chart-line" style="font-size: 36px;"></i>
    </div>
    <div class="absolute bottom-60 right-20 text-white opacity-80">
      <i class="pi pi-users" style="font-size: 38px;"></i>
    </div>

    <!-- Central Content -->
    <div class="absolute inset-0 flex items-center justify-center text-white text-center p-12">
      <div>
        <h2 class="text-4xl font-bold mb-6">Gerencie seu negócio</h2>
        <p class="text-xl opacity-90 leading-relaxed">
          Plataforma completa para controle de produtos, clientes e vendas
        </p>
      </div>
    </div>

    <!-- Decorative circles -->
    <div class="absolute top-10 right-10 w-32 h-32 border-2 border-white opacity-20 rounded-full"></div>
    <div class="absolute bottom-20 left-10 w-24 h-24 border border-white opacity-30 rounded-full"></div>
  </div>
</div>